import { createSelector } from 'reselect';

const getTickets = state => state.tickets.tickets;
const getPriceLevels = state => state.priceLevel.levels;
const getQuantities = state => state.ticketPicker.quantityArrays;

/**
 * Combines all tickets into groups organized by event and then price level
 * End object is of the form:
 *  {
 *      <event_id>:[{price_level_id: <id>...}, {price_level_id: <id2>...}...],
 *      <event_id2>:[{price_level_id: <id>...}, {price_level_id: <id2>...}...]
 *  }
 */
export const getPriceLevelSelectionsByEvent = createSelector(
    [getTickets, getPriceLevels, getQuantities],
    (tickets, priceLevels, quantities) => {
        let levels = {};
        for(var i = 0; i < tickets.length; i++) {
            const level = priceLevels[tickets[i].price_level_id];
            if (!level) {
                continue;
            }

            if(!levels[tickets[i].event_id]) {
                levels[tickets[i].event_id] = [{
                    price_level_id: tickets[i].price_level_id,
                    name: tickets[i].price_level_name,
                    price: level.price.price,
                    total_price: level.price.price,
                    fee: tickets[i].buyer_fee.amount,
                    total_fee: tickets[i].buyer_fee.amount,
                    quantity: 1,
                    subtotal: level.price.price + tickets[i].buyer_fee.amount,
                    currency: tickets[i].cost.currency,
                    currency_symbol: tickets[i].cost.symbol,
                    event_id: tickets[i].event_id,
                    quantities: quantities[tickets[i].price_level_id],
                    description: level.description
                }];
            } else {
                let found = false;
                for(var j = 0; j < levels[tickets[i].event_id].length; j++) {
                    if(levels[tickets[i].event_id][j].price_level_id === tickets[i].price_level_id) {
                        levels[tickets[i].event_id][j].total_price += level.price.price;
                        levels[tickets[i].event_id][j].total_fee += tickets[i].buyer_fee.amount;
                        levels[tickets[i].event_id][j].subtotal += (level.price.price + tickets[i].buyer_fee.amount);
                        levels[tickets[i].event_id][j].quantity++;
                        found = true;
                        break;
                    }
                }

                if(!found) {
                    levels[tickets[i].event_id].push(
                        {
                            price_level_id: tickets[i].price_level_id,
                            name: tickets[i].price_level_name,
                            price: tickets[i].cost.amount,
                            total_price: tickets[i].cost.amount,
                            fee: tickets[i].buyer_fee.amount,
                            total_fee: tickets[i].buyer_fee.amount,
                            quantity: 1,
                            subtotal: tickets[i].cost.amount + tickets[i].buyer_fee.amount,
                            currency: tickets[i].cost.currency,
                            currency_symbol: tickets[i].cost.symbol,
                            event_id: tickets[i].event_id,
                            quantities: quantities[tickets[i].price_level_id],
                            description: priceLevels[tickets[i].price_level_id].description
                        }
                    );
                }
            }
        }

        return levels;
    }
)

export const getNumTicketsByLevel = createSelector(
    [getTickets],
    (tickets) => {
        let levels = {};
        for(let i = 0; i < tickets.length; i++) {
            if(!levels[tickets[i].price_level_id]) {
                levels[tickets[i].price_level_id] = 1;
            } else {
                levels[tickets[i].price_level_id]++;
            }
        }
        return levels;
    }
);
